import script from "./PageAssistantSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageAssistantSelector.vue?vue&type=script&setup=true&lang=ts"

import "./PageAssistantSelector.vue?vue&type=style&index=0&id=0c50248e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c50248e"]])

export default __exports__